import { X } from 'lucide-react'

interface ConfirmDialogProps {
    isOpen: boolean
    onClose: () => void
    onConfirm: () => void
    title: string
    description: string
    confirmText?: string
    cancelText?: string
    variant?: 'danger' | 'warning' | 'info'
    loading?: boolean
}

export default function ConfirmDialog({
    isOpen,
    onClose,
    onConfirm,
    title,
    description,
    confirmText = 'Confirmar',
    cancelText = 'Cancelar',
    variant = 'danger',
    loading = false
}: ConfirmDialogProps) {
    if (!isOpen) return null

    const variantStyles = {
        danger: 'bg-red-500 hover:bg-red-600',
        warning: 'bg-yellow-500 hover:bg-yellow-600',
        info: 'bg-primary hover:bg-primary/90'
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm animate-in fade-in duration-200">
            <div className="glass-card max-w-md w-full p-6 animate-in zoom-in duration-200">
                <div className="flex items-start justify-between mb-4">
                    <h3 className="text-xl font-black text-primary uppercase">{title}</h3>
                    <button
                        onClick={onClose}
                        className="p-1 hover:bg-primary/5 rounded-lg transition-colors"
                        disabled={loading}
                    >
                        <X className="w-5 h-5 text-primary/60" />
                    </button>
                </div>

                <p className="premium-text mb-6">{description}</p>

                <div className="flex gap-3 justify-end">
                    <button
                        onClick={onClose}
                        className="px-6 py-2.5 bg-white border-2 border-slate-200 text-primary font-bold rounded-xl hover:bg-slate-50 transition-all uppercase text-sm tracking-wider"
                        disabled={loading}
                    >
                        {cancelText}
                    </button>
                    <button
                        onClick={onConfirm}
                        className={`px-6 py-2.5 text-white font-bold rounded-xl transition-all uppercase text-sm tracking-wider shadow-lg ${variantStyles[variant]} ${loading ? 'opacity-50 cursor-not-allowed' : ''}`}
                        disabled={loading}
                    >
                        {loading ? 'Processando...' : confirmText}
                    </button>
                </div>
            </div>
        </div>
    )
}
